import { render, staticRenderFns } from "./DialogExportMedicalRecords.vue?vue&type=template&id=96f171a6"
import script from "./DialogExportMedicalRecords.vue?vue&type=script&lang=js"
export * from "./DialogExportMedicalRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports